module.exports = __webpack_public_path__ + "img/52.eace8b44.jpg";